var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.7029,
    cy: 12,
    rx: 9.98997,
    ry: 10,
    stroke: "#EC187B",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2962 14.0871L13.0875 15.2776C11.7714 15.987 11.1133 16.3417 10.6259 16.0507C10.1385 15.7598 10.1385 15.0122 10.1385 13.5171L10.1385 11.1361C10.1385 9.64097 10.1385 8.89342 10.6259 8.60244C11.1133 8.31146 11.7714 8.66615 13.0875 9.37553L15.2962 10.566L15.2962 10.566C16.7353 11.3417 17.4549 11.7296 17.4549 12.3266C17.4549 12.9236 16.7353 13.3114 15.2962 14.0871Z",
    fill: "#EC187B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.bbd50c930fe1b587ba729c98ac7368f6.svg";
export { ForwardRef as ReactComponent };